import React from 'react'

function CalendarWeekDay ({ isToday = false, formattedDay = null }) {
  const classList = [
    'day',
    'cell',
    isToday ? 'today' : ''
  ]

  return (
    <div className={classList.join(' ')}>
      {formattedDay}
    </div>
  )
}

export default React.memo(CalendarWeekDay)
